export const dropdownCss = ({ isTruncate, overrideCss, customClassName, disabled = false, } = {}) => {
    const dropdown = [];
    const dropdownSelectionBox = [];
    const dropdownIcon = [];
    const dropdownLabel = [];
    const dropdownSelectedValue = [];
    const dropdownArrow = [];
    const dropdownOptionBox = [];
    const dropdownOptionItem = [];
    const dropdownOptionItemSelected = [];
    if (!overrideCss) {
        dropdown.push('dropdown');
        dropdownSelectionBox.push('dropdown__selection-box');
        dropdownIcon.push('dropdown__icon');
        dropdownLabel.push('dropdown__label');
        dropdownSelectedValue.push('dropdown__selected-value');
        dropdownArrow.push('dropdown__arrow');
        dropdownOptionBox.push('dropdown__option-box');
        dropdownOptionItem.push('dropdown__option-item');
        dropdownOptionItemSelected.push('dropdown__option-item');
        dropdownOptionItemSelected.push('dropdown__option-item--selected');
        if (isTruncate) {
            dropdownOptionItem.push('dropdown__option-item--truncate');
            dropdownOptionItemSelected.push('dropdown__option-item--truncate');
            dropdownLabel.push('dropdown__label--truncate');
            dropdownSelectionBox.push('dropdown__selection-box--truncate');
            dropdownSelectedValue.push('dropdown__selected-value--truncate');
        }
        if (disabled) {
            dropdownSelectionBox.push('dropdown__selection-box--disabled');
            dropdownSelectedValue.push('dropdown__selected-value--disabled');
        }
    }
    if (customClassName) {
        dropdown.push(`${customClassName}`);
        dropdownSelectionBox.push(`${customClassName}__selection-box`);
        dropdownIcon.push(`${customClassName}__icon`);
        dropdownLabel.push(`${customClassName}__label`);
        dropdownSelectedValue.push(`${customClassName}__selected-value`);
        dropdownArrow.push(`${customClassName}__arrow`);
        dropdownOptionBox.push(`${customClassName}__option-box`);
        dropdownOptionItem.push(`${customClassName}__option-item`);
        dropdownOptionItemSelected.push(`${customClassName}__option-item`);
        if (isTruncate) {
            dropdownOptionItem.push(`${customClassName}__option-item--truncate`);
            dropdownOptionItemSelected.push(`${customClassName}__option-item--truncate`);
            dropdownLabel.push(`${customClassName}__label--truncate`);
            dropdownSelectionBox.push(`${customClassName}__selection-box--truncate`);
            dropdownSelectedValue.push(`${customClassName}__selected-value--truncate`);
        }
        if (disabled) {
            dropdownSelectionBox.push(`${customClassName}__selection-box--disabled`);
            dropdownSelectedValue.push(`${customClassName}__label-__selected-value--disabled`);
        }
    }
    return {
        dropdown: dropdown.join(' '),
        dropdownSelectionBox: dropdownSelectionBox.join(' '),
        dropdownLabel: dropdownLabel.join(' '),
        dropdownSelectedValue: dropdownSelectedValue.join(' '),
        dropdownArrow: dropdownArrow.join(' '),
        dropdownOptionBox: dropdownOptionBox.join(' '),
        dropdownOptionItem: dropdownOptionItem.join(' '),
        dropdownOptionItemSelected: dropdownOptionItemSelected.join(' '),
        dropdownIcon: dropdownIcon.join(' '),
    };
};
//# sourceMappingURL=dropdownCss.js.map